import { Routes } from '@angular/router';

export const MOBILE_EMPLOYEES_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/employees-list/employees-list.component').then(
        c => c.EmployeesListPageComponent,
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/employees-history/employees-history.component').then(
        c => c.EmployeesHistoryComponent,
      ),
  },
];
